const initualState = {
  newReferral: {
    terms: null,
    allBanks: [],
    accountName: "",
    accountNumber: "",
    bankName: "",
    firstName: "",
    surname: "",
    otherNames: "",
    email: "",
    phone: "",
    nin: "",
    dateOfBirth: "",
    stateOfOrigin: "",
    lgaCode: ""
  },
  myReferrals: {
    result: [],
    from: new Date(),
    to: new Date()
  }
};

export default (state = initualState, action) => {
  switch (action.type) {
    case "SET_TERMS_AND_CONDITION":
      return {
        ...state,
        newReferral: { ...state.newReferral, terms: action.payload }
      };
    case "SET_ALL_BANKS":
      return {
        ...state,
        newReferral: { ...state.newReferral, allBanks: action.payload }
      };
    case "SET_REFERRAL_INPUT":
      return {
        ...state,
        newReferral: { ...state.newReferral, ...action.payload }
      };
    case "SET_MY_REFERRALS_INPUT":
      return {
        ...state,
        myReferrals: { ...state.myReferrals, ...action.payload }
      };
    default:
      return state;
  }
};
